import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";

//models
import { CebeProcedureViewModel } from "src/app/_core/models/centros/cebe-procedure.model";

//services
import { SettingsService } from "src/app/_core/providers/settings.service";
import { ContractService } from "src/app/modules/contracts/services/contract.service";

@Component({
	selector: "app-cebes-card",
	templateUrl: "./cebe-card.component.html",
	styleUrls: ["./cebe-card.component.scss"],
})
export class CebesCardComponent implements OnInit {
	constructor(
		public dialog: MatDialog,
		private readonly router: Router,
		private readonly _settingsService: SettingsService,
		private readonly contractService: ContractService,
	) {}

	@Input() chartdivId!: string;
	@Input() cebe: CebeProcedureViewModel;
	@Output() favEvent = new EventEmitter<string>();
	@Output() unfavEvent = new EventEmitter<string>();

	// Events
	ngOnInit(): void {
		// Cargar imagen desde el endpoint
		if (this.cebe.id) {
			this.contractService.getContractImage(this.cebe.id).subscribe({
				next: (imageData) => {
					if (imageData?.imageDataB64) {
						this.cebe.imageDataB64 = imageData.imageDataB64;
					} else {
						this.cebe.imageDataB64 =
							"/assets/images/services/alt.jpg";
					}
				},
				error: () => {
					// Si hay error, usar imagen por defecto
					this.cebe.imageDataB64 = "/assets/images/services/alt.jpg";
				},
			});
		} else {
			// Si no hay ID, usar imagen por defecto
			this.cebe.imageDataB64 = "/assets/images/services/alt.jpg";
		}
	}

	// Public methods
	goToCebe() {
		this.router.navigate([`/contracts/detail/${this.cebe.id}`]);
	}

	// Public methods
	public toggleFav() {
		if (this.cebe.isFav) {
			this._settingsService
				.unfavService(this.cebe.codigo)
				.subscribe((result) => {
					this.cebe.isFav = !this.cebe.isFav;
					this.unfavEvent.emit(this.cebe.codigo);
				});
		} else {
			this._settingsService.favService(this.cebe.codigo).subscribe(() => {
				this.cebe.isFav = !this.cebe.isFav;
				this.favEvent.emit(this.cebe.codigo);
			});
		}
	}
}
